









































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CompanySettingsEmmaDirectMail extends Vue {
    get tabs(): string[] {
        return [
            'printable_documents',
            'costs',
            'printed_documents',
        ]
    }
}
